import { resolveApiUrl } from "~/utils/url/urlResolver";
import { getCsrfValue } from "~/api/ApiHelper";

export interface ContactFormData {
  titleCode: string;
  salutationCode: string;
  firstName: string;
  lastName: string;
  email: string;
  description: string;
  dmcCode: string;
  files: File[];
}

export async function apiSendDMCContactForm(data: ContactFormData): Promise<boolean> {
  const apiUrl = resolveApiUrl(`/scandmcapi/contactForm`);

  const form = new FormData();
  form.append("salutationCode", data.salutationCode);
  form.append("titleCode", data.titleCode);
  form.append("firstName", data.firstName);
  form.append("lastName", data.lastName);
  form.append("email", data.email);
  form.append("description", data.description);
  form.append("dmcCode", data.dmcCode);
  data.files.forEach((file) => {
    form.append("files", file);
  });

  try {
    const response = await fetch(apiUrl, {
      body: form,
      method: "POST",
      cache: "no-cache",
      credentials: "same-origin", // include, omit
      mode: "cors", // no-cors, same-origin
      referrer: "no-referrer", // client
      headers: {
        CSRFToken: getCsrfValue(),
      },
    });
    if (!response.ok) {
      return false;
    }
  } catch (e) {
    console.error(e);
    return false;
  }
  return true;
}
